/* AlpinestarsJacket — theme.js */

document.addEventListener('DOMContentLoaded', function () {

  // ===== FAQ ACCORDION =====
  document.querySelectorAll('.faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const item = this.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function (i) { i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });

  // ===== TABS (Product page) =====
  document.querySelectorAll('.tab-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const target = this.dataset.tab;
      document.querySelectorAll('.tab-btn').forEach(function (b) { b.classList.remove('active'); });
      document.querySelectorAll('.tab-content').forEach(function (c) { c.classList.remove('active'); });
      this.classList.add('active');
      const el = document.getElementById('tab-' + target);
      if (el) el.classList.add('active');
    });
  });

  // ===== SIZE BUTTONS =====
  document.querySelectorAll('.size-grid').forEach(function (grid) {
    grid.querySelectorAll('.size-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (this.classList.contains('sold-out')) return;
        grid.querySelectorAll('.size-btn').forEach(function (b) { b.classList.remove('active'); });
        this.classList.add('active');
      });
    });
  });

  // ===== COLOR SWATCHES =====
  document.querySelectorAll('.color-grid').forEach(function (grid) {
    grid.querySelectorAll('.color-swatch').forEach(function (sw) {
      sw.addEventListener('click', function () {
        grid.querySelectorAll('.color-swatch').forEach(function (s) { s.classList.remove('active'); });
        this.classList.add('active');
      });
    });
  });

  // ===== QUANTITY BUTTONS =====
  document.querySelectorAll('.product-qty').forEach(function (wrap) {
    const val = wrap.querySelector('.product-qty__val');
    wrap.querySelector('[data-qty-minus]')?.addEventListener('click', function () {
      let v = parseInt(val.textContent);
      if (v > 1) val.textContent = v - 1;
    });
    wrap.querySelector('[data-qty-plus]')?.addEventListener('click', function () {
      val.textContent = parseInt(val.textContent) + 1;
    });
  });

  // ===== PRODUCT GALLERY THUMBS =====
  document.querySelectorAll('.product-gallery__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      const gallery = this.closest('.product-gallery');
      gallery?.querySelectorAll('.product-gallery__thumb').forEach(function (t) { t.classList.remove('active'); });
      this.classList.add('active');
      const src = this.dataset.src;
      const mainImg = gallery?.querySelector('.product-gallery__main img');
      if (src && mainImg) mainImg.src = src;
    });
  });

  // ===== STICKY NAV SHADOW =====
  window.addEventListener('scroll', function () {
    const nav = document.querySelector('.site-nav');
    if (nav) {
      nav.style.boxShadow = window.scrollY > 10 ? '0 4px 24px rgba(0,0,0,0.08)' : 'none';
    }
  });

  // ===== ADD TO CART FEEDBACK =====
  document.querySelectorAll('.btn-atc, .product-card__atc').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const orig = this.textContent;
      this.textContent = '✓ Added!';
      this.style.background = '#2a7a2a';
      const self = this;
      setTimeout(function () {
        self.textContent = orig;
        self.style.background = '';
      }, 1800);
    });
  });

});
